<script>
  import {
    DataTable,
    ToolbarSearch,
    ToolbarContent,
    Link,
  } from "carbon-components-svelte";
  import { config } from "./configs/k12-workshops.js";
  import { onMount } from "svelte";
  import Papa from "papaparse";
  import { search } from "./lib/search.js";
  let data = [];
  let error = {};

  let searchTerm = "";

  onMount(async () => {
    Papa.parse(config.url, {
      download: true,
      header: true,
      complete: function (results) {
        data = results.data;
        data.sort((a,b) => {
            return a.Topic > b.Topic;
        })
        .map((entry, index) => {
          entry.id = index;
        });
        console.log(data)
      },
      error: function (err) {
        error = err;
        console.log(err);
      },
    });
  });
</script>

<main style="overflow:scroll; min-height: 500px;">
  {#if data.length === 0}
    <div class="loading">
      <p>...Loading Data</p>
    </div>
  {:else}
    <!-- svelte-ignore missing-declaration -->
    <DataTable
      sortable
      title={config.title != "" && config.title}
      description={config.description != "" && config.description}
      rows={search(searchTerm, data, config.searchFields)}
      headers={config.headers}
    >
      <ToolbarContent>
        <ToolbarSearch persistent bind:value={searchTerm} />
      </ToolbarContent>
      <svelte:fragment slot="cell" let:row let:cell>
        {#if cell.key === config.link?.field && config.link?.url}
          <Link aria-label={cell.value + " offered by "  + row["Provider"] + " for " + row["Dept"] + " " + row["Course No"]} href={row[config.link.url]} target="_blank">{cell.value}</Link>
        {:else if cell.value.slice(0, 2) == "<a"}
          {@html cell.value}
        {:else}
          {cell.value}
        {/if}
      </svelte:fragment>
    </DataTable>
  {/if}
</main>
<div data-iframe-height="" />

<style>
</style>
